<section id="promos">
  <!-- own-carousel version -->
  <owl-carousel-o [options]="customOptions" (dragging)="isDragging.set($event.dragging)">
    <ng-container *ngFor="let p of staticPromos; let i = index;">
      <ng-template carouselSlide>
        <div class="d-flex bg-darkest p-3 me-2 h-100">
          <div class="row w-100">
            <div class="col-8">
              <div class="h-100 d-flex flex-column justify-content-between">
                <div class="">
                  <span class="badge bg-lighter mb-2">{{ (p.details.includes('welcome') ? 'PROMOTIONS.WELCOME' : 'PROMOTIONS.WEEKLY') | translate }}</span>
                </div>
                <div>
                  <h3 class="fw-bold mb-0">{{ ('PROMOTIONS.' + p.id + '_NAME') | translate }}</h3>
                  <a owlRouterLink="/promotions/{{p.name}}" [stopLink]="isDragging()">{{ 'PROMOTIONS.MORE_INFO_LINK' | translate}}</a>
                </div>
                <div>
                  <a class="btn btn-outline-secondary" type="button" owlRouterLink="{{user ? '/account/promotions' : '/promotions'}}" [stopLink]="isDragging()">{{ 'PROMOTIONS.GET_BTN' | translate }}</a>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="h-100 d-flex align-items-center">
                <img src="{{ p.imgPath ?? 'assets/icons/promotions.svg' }}" alt="promo image" style="height: auto;" loading="lazy">
              </div>
            </div>
          </div>

        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</section>
